import Migration from './migration'

export default class M001 extends Migration {

    constructor() {
        super('M001 - Initial Migration',
            async(authContext) => {
                await this.upsertAsync('migrations', authContext, { applied: [] })
            })
    }
}
